module.exports = __webpack_public_path__ + "img/partner 17.79052180.png";